import { render } from "./GridControlTable.vue?vue&type=template&id=32f35b4f&scoped=true"
import script from "./GridControlTable.vue?vue&type=script&lang=js"
export * from "./GridControlTable.vue?vue&type=script&lang=js"

import "./GridControlTable.vue?vue&type=style&index=0&id=32f35b4f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f35b4f"]])

export default __exports__